module.exports = __webpack_public_path__ + "img/56_72.ec6e0307.png";